import { render, staticRenderFns } from "./PayGreen.vue?vue&type=template&id=1f031866"
import script from "./PayGreen.vue?vue&type=script&lang=ts"
export * from "./PayGreen.vue?vue&type=script&lang=ts"
import style0 from "./PayGreen.vue?vue&type=style&index=0&id=1f031866&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f031866')) {
      api.createRecord('1f031866', component.options)
    } else {
      api.reload('1f031866', component.options)
    }
    module.hot.accept("./PayGreen.vue?vue&type=template&id=1f031866", function () {
      api.rerender('1f031866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/PayGreen.vue"
export default component.exports